const Constants = Object.freeze({
  DefaultPauseDuration: 1.5,
});
export default Constants;
